import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import UserPermission from 'components/User/Permission';

const ScreenUserPermission = props => {
  const { match } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} lg={10} xl={8}>
        <UserPermission id={match.params.id} />
      </GridItem>
    </GridContainer>
  );
};

ScreenUserPermission.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default ScreenUserPermission;
